export const baseURL = 'https://norma.nomoreparties.space';
export const wssAllOrdersURL = 'wss://norma.nomoreparties.space/orders/all';
export const wssUserOrdersURL = 'wss://norma.nomoreparties.space/orders';
export const pathIngredients = '/api/ingredients';
export const pathOrders = '/api/orders';
export const pathAuthLogin = '/api/auth/login';
export const pathAuthRegister = '/api/auth/register';
export const pathAuthLogout = '/api/auth/logout';
export const pathAuthToken = '/api/auth/token';
export const pathAuthUser = '/api/auth/user';
export const pathInitPasswordReset = '/api/password-reset'
export const pathSubmitNewPassword = '/api/password-reset/reset'

export const cookieMaxAgeDays = 1;
